module.exports = __webpack_public_path__ + "static/partnership_img3@2x-719f5e3e5c64fbdaa3f77dbe9363fd60.jpg";